<template>
  <v-row>
    <v-col cols="12">
      {{ label }}
    </v-col>
    <v-col class="flex-grow-0 flex-shrink-1">
      <v-select v-model="hours"
                :items="selects.hours"></v-select>
    </v-col>
    <v-col class="flex-grow-0 flex-shrink-1" align-self="center">:</v-col>
    <v-col class="flex-grow-0 flex-shrink-1">
      <v-select v-model="minutes"
                :items="selects.minutes"></v-select>
    </v-col>
    <v-col class="flex-grow-0 flex-shrink-1">
      <v-select v-model="pm"
                :items="selects.ampm"
                @change="update(hours, minutes)"></v-select>
    </v-col>
    <v-spacer></v-spacer>
  </v-row>
</template>

<script>
/**
 * Generates a digital time range based on a C# TimeSpan object in HH:MM:SS format
 *
 * Vuetify's Analog time picker is weird and I hate it:
 * https://vuetifyjs.com/en/components/time-pickers/
 *
 * This also ignores seconds, as that information is not useful for what we need
 *
 * Number selection involves a bit of shorthand magic.
 *
 * We just need an array populated with numbers 0-X,
 * so we just unpack the keys of an Array of length X
 *
 * I use this approach for both Hour and Minute item selects
 */
export default {
  name: 'TimePicker',
  model: {
    prop: 'value',
    event: 'timepickerupdate',
  },
  props: {
    value: String,
    label: String,
  },
  data() {
    return {
      pm: false,
      selects: {
        hours: [...Array(12).keys()].map((m) => ({ text: `${m || 12}`.padStart(2, '0'), value: m })),
        minutes: [...Array(60).keys()].map((m) => ({ text: `${m}`.padStart(2, '0'), value: m })),
        ampm: [
          { text: 'AM', value: false },
          { text: 'PM', value: true },
        ],
      },
    };
  },
  computed: {
    hours: {
      get() {
        const [hours] = this.getHoursAndMinutes();
        return hours > 12 ? hours - 12 : hours;
      },
      set(v) {
        this.update(v, this.minutes);
      },
    },
    minutes: {
      get() {
        const [, minutes] = this.getHoursAndMinutes();
        return minutes;
      },
      set(v) {
        this.update(this.hours, v);
      },
    },
  },
  methods: {
    getHoursAndMinutes() {
      return this.value
        ? this.value.split(':').map((v) => parseInt(v, 10))
        : [0, 0];
    },
    update(hours, minutes) {
      const hh = `${hours + (this.pm ? 12 : 0)}`.padStart(2, '0');
      const mm = `${minutes}`.padStart(2, '0');
      const ss = '00';
      this.$emit('timepickerupdate', `${hh}:${mm}:${ss}`);
    },
  },
  mounted() {
    // This just makes sure that we're putting 12 up at the top rather than the bottom
    this.selects.hours.sort((a, b) => {
      if (a.value !== b.value) {
        return (a.value || 12) - (b.value || 12);
      }
      return 0;
    });

    const [hours] = this.getHoursAndMinutes();
    this.pm = hours >= 12;
  },
};
</script>
